import { useEffect, useState } from "react";
import { MwButton } from "../../ui";
import { useCurrent, usePost } from "../../../hooks";
import { langObjType, objLangTextHandler } from "../../../utils/global";
import CardHeadeWithActions from "../../ui/CardHeadeWithActions";
import GroupForm from "./GroupForm";
import { useTranslation } from "react-i18next";
import { invalidateFetchCache } from "../../../hooks/useFetch";

const CreateGroup = ({ setMode }) => {
  const { data: postResult, postData } = usePost();
  const { currentLangList, currentTenantId, currentCompanyId, currentBranchId, currentLangId } =
    useCurrent();
  const [formLang, setFormLang] = useState(currentLangId);
  const [errors, setErrors] = useState({});
  const [t] = useTranslation("global");

  const [groupName, setGroupName] = useState(langObjType());
  const [groupDesc, setGroupDesc] = useState(langObjType());
  const [isActive, setIsActive] = useState(true);

  const formValidate = () => {
    let errorObj = {};
    setErrors("");
    if (!groupName[currentLangId]) {
      errorObj = { ...errorObj, [`groupName.${currentLangId}`]: t("vendorGroups.groupNameRequired") };
      setFormLang(currentLangId);
    }

    if (Object.keys(errorObj).length !== 0) {
      setErrors(errorObj);
      return true;
    }

    return false;
  };
  const submitHandler = () => {
    if (formValidate()) return;

    const _data = {
      groupName: objLangTextHandler(groupName),
      groupDesc: objLangTextHandler(groupDesc),
      isActive,
      tenantId: currentTenantId,
      companyId: currentCompanyId,
      branchId: currentBranchId,
    };

    postData(`${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/groups`, _data);
  };

  useEffect(() => {
    if (postResult) {
      const groupsListUrl =
        currentTenantId && currentCompanyId && currentBranchId
          ? `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/groups/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
          : null;
      invalidateFetchCache(groupsListUrl);
      setMode("List");
    }
  }, [
    postResult,
    currentTenantId,
    currentCompanyId,
    currentBranchId,
    setMode,
  ]);

  return (
    <>
      <CardHeadeWithActions title={t("vendorGroups.createGroup")}>
        <MwButton inGroup={true} type="cancelBtn" onClick={() => setMode("List")}>
          {t("vendorGroups.manageVendorGroups")}
        </MwButton>
        <MwButton type="saveBtn" onClick={submitHandler} inGroup={true}>
          {t("vendorGroups.save")}
        </MwButton>
      </CardHeadeWithActions>
      <GroupForm
        currentLangList={currentLangList}
        formLang={formLang}
        setFormLang={setFormLang}
        errors={errors}
        groupName={groupName}
        setGroupName={setGroupName}
        groupDesc={groupDesc}
        setGroupDesc={setGroupDesc}
        isActive={isActive}
        setIsActive={setIsActive}
      />
    </>
  );
};

export default CreateGroup;
